import Route from '@ember/routing/route';

export default class ListsRoute extends Route {}
